/**
 * 
 * Adds back the correct color settings for the Content area Layout 1
 *
 * @example
 * contentLayout1BgClr()
 *
 */

function contentLayout1BgClr() {

    // console.log('bg check -------------------')
    
    const homeContent = document.querySelector('.home #yieldContent');
    const targetPanel = document.querySelector('.home #panelTwo .layoutContainer.row.layout-66-33');

    // const targetA = document.querySelector('.home');
    // const targetB = document.querySelectorAll('.home .layoutContainer');

    // console.dir(targetA)
    // console.dir(targetB)
    
    // console.log('homeContent: ' + homeContent)
    // console.log('targetPanel: ' + targetPanel)

    
    if (!homeContent || !targetPanel) return;
    
    const bgColor = window.getComputedStyle(homeContent).backgroundColor;
 
    // console.log('bc color: ' + bgColor)
    
    if (bgColor === 'rgb(255, 255, 255)') {
        // change bg color to transparent
        homeContent.style.backgroundColor = 'transparent';
        // Get current classes
        const currentClasses = targetPanel.className;
        // Remove existing classes
        targetPanel.className = '';
        // Add bg-clr-white first, then existing classes
        targetPanel.className = `content-layout-1-clr ${currentClasses}`;
        // console.log(`content-layout-1-clr ${currentClasses}`)
    }
}

